export default "__VITE_ASSET__DevQjgI1__"